import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.prependIcon
        ? _c(VIcon, { attrs: { left: "", "x-small": "" } }, [
            _vm._v(_vm._s(_vm.prependIcon)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.$t(_vm.i18nKey, _vm.params)) },
      }),
    ],
    1,
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }